import { collection, getDocs, query, where, doc, updateDoc } from "firebase/firestore";

export const fetchTeamMembersByOrganization = async ({ db, organizationId, currentUserUid }) => {
  const q = query(
    collection(db, "users"),
    where("organizationId", "==", organizationId)
  );
  const snapshot = await getDocs(q);

  return snapshot.docs
    .map((docSnap) => ({ uid: docSnap.id, ...docSnap.data() }))
    .filter((member) => member.uid !== currentUserUid);
};

export const toggleMemberFinancePermission = async ({ db, memberUid, currentValue }) => {
  await updateDoc(doc(db, "users", memberUid), {
    canManageFinance: !currentValue,
  });

  return !currentValue;
};
